import * as errors from "../errors.js";
import { state } from "../state.js";

/*
    SPC can be used to set a number of spaces, which are either written into a file or printed onto screen. SPC can be used several times in a sentence.
    The valid number of spaces range from 0 to 255, other values will cause the BASIC-error ?ILLEGAL QUANTITY ERROR IN line to occur. 
    If using a non-numerical argument the BASIC-error ?TYPE MISMATCH ERROR IN line will appear. When the numerical argument is missing the 
    BASIC-error ?SYNTAX ERROR IN line is displayed.
    Note that when SPC is used for writing spaces into a file the maximum number of spaces is 254. Also note that SPC will not overwrite and erase things 
    already printed on screen, so PRINT SPC(3) is not the same as PRINT" " in that respect.
    If the SPC is the last item on the line in a PRINT statement, the carriage return that would normally be inserted at the end will be suppressed. 
    This is also true for the TAB function, as well as trailing commas or semicolons.
    When outputting to a printer and the last column in the actual print-line is reached, the printer automatically makes a carriage return and a linefeed. 
*/
export const spc = async (args) => {
    // If no args are given, throw a syntax error.
    if (args.length === 0) {
        throw new errors.SyntaxError();
    }

    // Check if the args is a number.
    if (isNaN(args)) {
        throw new errors.TypeMismatchError();
    }

    // Check for illegal quantity.
    if (args < 0 || args > 255) {
        throw new errors.IllegalQuantityError();
    }
    
    // Create a string with the specified number of spaces.
    return " ".repeat(args);
};